import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MmcSettingsBillingDefaultsGridLayoutService} from "@irb/irb-settings/settings-mmc/mmc-billing-defaults-settings/mmc-settings-billing-defaults.grid-layout.service";

@Component({ standalone: false,
  selector: 'irb-mmc-billing-defaults-settings',
  templateUrl: './mmc-billing-defaults-settings.component.html',
  styleUrls: ['./mmc-billing-defaults-settings.component.scss']
})
export class MmcBillingDefaultsSettingsComponent implements OnInit {

  gridOptions: any;
  grid: any;
  _data: any;
  frameworkComponents: any;

  @Input()
  get data() {
    return this._data;
  }

  @Output()
  changed: EventEmitter<any> = new EventEmitter<any>();

  set data(value: any) {
    this._data = value;
    this.loadGrid();
  }

  constructor(private gls: MmcSettingsBillingDefaultsGridLayoutService) {
  }

  ngOnInit(): void {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(this),      
      floatingFilter: false,
      overlayNoRowsTemplate:
          "<span class='ag-overlay-loadGriding-center ag-overlay-message'>No billing tiers defined.</span>",
      context: {componentParent: this},
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this)
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass(node: any) {
    return !node.data.isUIdeleted;
  }

  onGridReady(params: any) {
    this.grid = params;
  }

  private loadGrid() {
    if (this.grid && this.grid.api && this.data) {
      this.grid.api.setGridOption('rowData', this.data);
    }
  }

  triggerChangedEvent() {
    this.changed.next(this.data);
  }
  canEdit(params: any) {
    return !params.data.isEditable;
  }
  onRangeUpdate() {
    this.triggerChangedEvent();
  }
  onTDAPercentOfNERUpdate() {
    this.triggerChangedEvent();
  }
  onBillingTypeChanged() {
    this.triggerChangedEvent();
  }

}
